const map = {
  long: 3500,
  short: 2000,
};
let toastList: Array<{
  _key: string;
  ele: HTMLDivElement;
  timer: NodeJS.Timeout | null;
}> = [];

let index = 0;

const getUid = () => {
  const key = new Date().getTime();
  return `toast_${key}_${index++}`;
};
const fixedStyle = `
  min-height:30px;
  font-size:14px;
  box-shadow:0px 10px 18px 0px #1B202A1A;
  background-color:#FFFFFF;
  color:#1B202A;
  border: 1px solid #E8E8E9;
  margin:5px;
  padding:9px 12px;
  display:flex;
  flex-wrap:wrap;
  justify-content:center;
  align-items:center;
  min-width:100px;
  width:fit-content;
  max-width:100%;
  overflow-wrap:anywhere;
  `;

const style = {
  toastHide: `${fixedStyle}opacity:0;transition:0.4s;`,
  toast: `${fixedStyle}opacity:1;`,
};

function creatToast(
  content: string,
  duration: "long" | "short",
  container: HTMLElement
) {
  const ele = document.createElement("div");
  ele.setAttribute("class", "toast");
  const _key = getUid();
  ele.setAttribute("key", _key);
  ele.setAttribute("style", style.toast);
  ele.innerText = content;

  const timer = setTimeout(() => {
    //实现淡出效果
    ele.setAttribute("style", style.toastHide);
    const t = setTimeout(() => {
      container.removeChild(ele);
      clearTimeout(t);
    }, 400);
    toastList = toastList.filter(
      (item) => item?._key !== ele.getAttribute("key")
    );
    clearTimeout(timer);
  }, map[duration]);

  return { _key, ele, timer };
}

export function toast(content: string, duration: "long" | "short") {
  let container: HTMLElement = document.getElementById("toast_container");
  if (!container) {
    toastList = [];
    container = document.createElement("div");
    container.setAttribute("id", "toast_container");
    container.setAttribute(
      "style",
      `
      display:flex;
      flex-direction:column;
      align-items:center;
      position:absolute;
      z-index:9999;
      top:${Math.ceil(document.body.offsetHeight * 0.1)}px;
      left:50%;
      transform: translate(-50%,0);
      max-width:${document.body.offsetWidth - 60}px;`
    );
    document.body.appendChild(container);
  }

  const height = document.body.offsetHeight;

  if (container.offsetHeight + Math.ceil(height * 0.2) > height) {
    const first = container.firstChild;
    const firstKey = (first as Element).getAttribute("key");
    toastList = toastList.filter((item) => {
      if (item?._key == firstKey) {
        container.removeChild(first);
        clearTimeout(item.timer);
      }
      return item._key !== firstKey;
    });
  }

  const { _key, ele, timer } = creatToast(content, duration, container);
  toastList.push({ _key, ele, timer });

  container.appendChild(ele);
}
